export const appInfoSliceName = 'appInfo';
